import {Injectable} from '@angular/core';
import { TranslationService} from "@cbcore/services/translation/translation.service";
import {Store} from "@ngrx/store";
import {AppState, callCoreSettings, selectConfigurationCore} from "@cbcore/NGRX/core.state";
import {callFxRates} from "@cbcore/NGRX/configuration/configuration.actions";
import {selectMenuLoaded} from "@cbcore/NGRX/pool/pool.selectors";
import {combineLatest, takeWhile} from "rxjs";

@Injectable()
export class AppConfig {
  constructor(
    public translationService: TranslationService,
    private store: Store<AppState>
  ) {
  }

  loadInitialData(): any {
    const langaugeLoaded$ = this.translationService.ready();
    const menuLoaded$ = this.store.select(selectMenuLoaded);
    const configuration$ = this.store.select(selectConfigurationCore).pipe(takeWhile(data => data === undefined, true));

    const selectionsCombined$ = combineLatest([langaugeLoaded$, menuLoaded$, configuration$]);

    this.store.dispatch(callFxRates());
    this.store.dispatch(callCoreSettings());


    return new Promise((resolve, _reject) => {
      this.translationService.onInit();
      selectionsCombined$.subscribe({
        next: ([language, menu, configuration]) => {
          if (menu && language && configuration) {
            resolve(true);
          }
        },
        error: () => {
          resolve(true);
        },
        complete: () => {
          resolve(true);
        }
      })
    });
  }
}
